import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/site";

const LINKS = [
  { id: "learn", label: "What You’ll Learn" },
  { id: "how", label: "How It Works" },
  { id: "about", label: "About" },
];

export function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-3 sm:top-4 inset-x-0 z-50 px-3 sm:px-6" data-testid="site-nav">
      <nav
        className={`mx-auto max-w-5xl rounded-full glass flex items-center justify-between pl-5 pr-2 py-2 transition-[background-color,box-shadow] duration-300 ${scrolled ? "" : "bg-white/60"}`}
        aria-label="Main"
      >
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="font-display font-bold tracking-[0.28em] text-[#0B1F3A] text-lg" data-testid="nav-wordmark">
          FAD
        </button>
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="text-sm text-[#172033]/80 hover:text-[#0B1F3A] transition-colors" data-testid={`nav-link-${l.id}`}>
              {l.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-1">
          <button onClick={() => go("booking")} className="btn-primary !py-2.5 !px-5 !text-sm" data-testid="nav-book-briefing-button">
            Book a Briefing
          </button>
          <button className="md:hidden p-2.5 rounded-full hover:bg-black/5" onClick={() => setOpen((o) => !o)} aria-label="Toggle menu" aria-expanded={open} data-testid="nav-mobile-menu-toggle">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="md:hidden mx-auto max-w-5xl mt-2 rounded-3xl glass p-2" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="block w-full text-left px-4 py-3 rounded-2xl text-[15px] hover:bg-black/5" data-testid={`nav-mobile-link-${l.id}`}>
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
